import React, { Fragment } from "react";
import { ReactComponent as BackIcon } from "../../../../assets/utils/images/svgs/arrow-left.svg";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import { useNavigate } from "react-router";
import { Button, CardFooter } from "reactstrap";
import { useGebruikerContext } from "../Context/GebruikerContext";
import { getActiveTab, getTabsMenus } from "../Common/helpers";

const Gebruikers = () => {
	const { currentUser, activeTab, setActiveTab, tabsLoader, isActiveTab, userTabs } =
		useGebruikerContext();
	const navigate = useNavigate();
	const tabsList = getTabsMenus(userTabs);

	return Object.keys(currentUser).length !== 0 ? (
		<Fragment>

			<div className=" gebruikers-view">
				{Object.keys(currentUser).length !== 0 &&
					currentUser?.data?.name &&
					currentUser?.data?.clooserId && <PageHeading data={currentUser} />}
				<TransitionOnLoad>
					<Fragment>
						<div
							className="d-flex gap-4 side-tabs"
							style={{
								marginBottom: `${activeTab === userTabs.Urenoverzicht ||
									activeTab === userTabs.Beschikbaarheid
									? "50px"
									: "20px"
									}`,
							}}
						>
							<div
								className={
									activeTab === userTabs.Beschikbaarheid
										? "w-auto user-ctn col"
										: " user-ctn w-auto col"
								}
							>
								{getActiveTab(userTabs, activeTab)}
							</div>
							{activeTab !== userTabs.Beschikbaarheid && (
								<div className="users-tab planscreen-gebruikers__tabs">
									{!tabsLoader &&
										tabsList.map((item) => {
											return (
												<p
													key={item.key}
													className={
														isActiveTab(item.key)
															? "active"
															: ""
													}
													onClick={() => {
														setActiveTab(item.key);
													}}
												>
													{item.icon} {item.name}
												</p>
											);
										})}
								</div>
							)}
						</div>
					</Fragment>
				</TransitionOnLoad>
			</div>

			{activeTab === userTabs.Profiel ? (
				<div className="chat-layout-footer">
					<CardFooter className="chat-layout-footer__inner gebruikers-footer">
						<div className="d-flex gap-3 w-100 pe-4">
							<Button
								outline
								className="btn-outline-primary-blue ms-auto"
								onClick={() => {
									navigate(-1);
								}}
								type="button"
								color="primary"
							>
								<BackIcon />
							</Button>
						</div>
					</CardFooter>
				</div>
			) : (
				<></>
			)}



		</Fragment>
	) : null;
};

export default Gebruikers;
